<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="header accent-700 p-24">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="contact-name mt-8">Cadastro de Firma</div>
            <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>


    <div mat-dialog-content class="p-12 pb-0 m-0">

        <form [formGroup]="firmForm" class="w-100-p">
            <div fxLayout="column" class="w-100-p">
                <div fxLayout="row" class="w-100-p" fxLayoutGap="10">

                    <mat-form-field appearance="outline" class="w-100-p">
                        <mat-label>Nome</mat-label>
                        <input id="tables-general-firm-name-edit-form_it" matInput maxlength="255" name="name"
                            formControlName="name" cwgAutoFocusDirective required>
                        <mat-error *ngIf="firmForm.get('name').hasError('required')">
                            O campo é obrigatório
                        </mat-error>
                        <mat-error *ngIf="firmForm.get('name').hasError('maxlength')">
                            Campo excedeu 255 caracteres
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100-p">
                        <mat-label>Nome Completo</mat-label>
                        <input id="tables-general-firm-fullName-edit-form_it" matInput maxlength="255" name="fullName"
                            formControlName="fullName" required>
                        <mat-error *ngIf="firmForm.get('fullName').hasError('required')">
                            O campo é obrigatório
                        </mat-error>
                        <mat-error *ngIf="firmForm.get('fullName').hasError('maxlength')">
                            Campo excedeu 255 caracteres
                        </mat-error>
                    </mat-form-field>
                </div>
                <div fxLayout="row" class="w-100-p" fxLayoutGap="10">
                    <mat-form-field appearance="outline" class="w-100-p">
                        <mat-label>Tipo</mat-label>
                        <mat-select id="tables-general-firm-registryType-edit-form_cs" [compareWith]="compareSelect"
                            name="registryType" formControlName="registryType" required>
                            <mat-option value="null">
                                Selecione
                            </mat-option>
                            <mat-option *ngFor="let registryType of registryTypeList" [value]="registryType">
                                {{registryType.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="firmForm.get('registryType').hasError('required')">
                            O campo é obrigatório
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100-p">
                        <mat-label>Inscrição</mat-label>
                        <input id="tables-general-firm-registry-edit-form_it" matInput maxlength="15" name="registry"
                            formControlName="registry" required>
                        <mat-error *ngIf="firmForm.get('registry').hasError('required')">
                            O campo é obrigatório
                        </mat-error>
                        <mat-error *ngIf="firmForm.get('registry').hasError('maxlength')">
                            Campo excedeu 15 caracteres
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100-p">
                        <mat-label>CNES</mat-label>
                        <input id="tables-general-firm-cnes-edit-form_it" matInput maxlength="7" name="cnes"
                            formControlName="cnes" required>
                        <mat-error *ngIf="firmForm.get('cnes').hasError('required')">
                            O campo é obrigatório
                        </mat-error>
                        <mat-error *ngIf="firmForm.get('cnes').hasError('maxlength')">
                            Campo excedeu 7 caracteres
                        </mat-error>
                    </mat-form-field>
                </div>
              
            </div>
        </form>
    </div>

    <div mat-dialog-actions class=" m-0 p-16" fxLayout="row" fxLayoutAlign="end end">
        <button mat-raised-button (click)="dimiss()" class="mr-12">
            Cancelar
        </button>
        <button mat-raised-button [disabled]="loading" (click)="insert()" color="accent">
            Confirmar
        </button>
    </div>
</div>